import config from '../config'
import Firebase from 'firebase'

import firebase from "firebase/app";
import "firebase/storage";
import "firebase/app";
import "firebase/auth";
let app = Firebase.initializeApp(config);
let dbapp = app.database();

const dbSoli = dbapp.ref("SolicitudesParaConductor");
const dbPagos = dbapp.ref("PagosVerificados");
const dbUser = dbapp.ref("usuarios");
const dbListPagos = dbapp.ref("Pagos")
const dbPendingSoli = dbapp.ref("Solicitudes_Pendientes")
const dbViajes = dbapp.ref("viajes")
const dbViajesRealizados = dbapp.ref("ViajesRealizados")
const dbSolicitudesVerificadas = dbapp.ref("Solicitudes_Verificadas")
const dbCostos = dbapp.ref("CostosAcumulados")
const dbConductores = dbapp.ref("Conductores");
const dbRay = dbapp.ref("plissRay"); //
const dbMarcas = dbapp.ref("Marca_vehiculo")
const dbSoliNormal = dbapp.ref("SolicitudesConductorNormal")

class FirebaseService {

  getSolicitudesANormal() {
    return dbSoliNormal;
  };

  getConductores() {
    return dbConductores;
  };

  getMarcas() {
    return dbMarcas;
  };

  getRay() {
    return dbRay;
  };

  DetalleAcumulados() {
    return dbCostos;

  }

  guardarUsuarios(user) {
    if (!user.id) {
      user.id = Date.now();
    }
    return dbapp.ref("usuarios/" + user.id).set(user);
  }

  //solicitudes verifiacada
  getSolicitudesVeri() {
    return dbSolicitudesVerificadas;
  };

  //VIAJES
  getViajes() {
    return dbViajes;
  };

  getViajesRealizados() {
    return dbViajesRealizados;
  };
  //Solicitudes 
  getSolicitudes() {
    return dbSoli;
  };

  getPagos() {
    return dbPagos;
  };

  getPendingSoli() {
    return dbPendingSoli;
  };

  getListPagos() {
    return dbListPagos;
  };
  getPagosFB(pago) {
    return dbapp.ref('Pagos/' + pago.id).set(pago);
  }

  removerPagosFB(pago) {
    return dbapp.ref('Pagos/' + pago.id).remove();
  }


  getUser() {
    return dbUser;
  };

  updateUser(user) {
    return dbapp.ref('usuarios/' + user.id).set(user);
  }

  getUserFB(id) {
    return dbapp.ref("usuarios/" + id);
  }

  getconductorFB(id) {
    return dbapp.ref("Conductores/" + id);
  }

  updateConductor(user) {
    return dbapp.ref('Conductores/' + user.id).set(user);
  }

  updateSolicitud(soli) {
    return dbapp.ref('SolicitudesParaConductor/' + soli.id).set(soli);
  }

  updateSolicitudNormal(soli) {
    return dbapp.ref('SolicitudesConductorNormal/' + soli.id).set(soli);
  }

  guardarSolicitud(soli) {
    if (!soli.id) {
      soli.id = new Date();
    }
    return dbapp.ref('SolicitudesParaConductor/' + soli.id).set(soli);
  }
  guardarSolicitudNormal(soli) {
    if (!soli.id) {
      soli.id = new Date();
    }
    return dbapp.ref('SolicitudesConductorNormal/' + soli.id).set(soli);
  }

  updatePagos(pago) {
    return dbapp.ref('Pagos/' + pago.id).set(pago);
  }
  getSolicitudFB(id) {
    return dbapp.ref("SolicitudesParaConductor/" + id);
  }

  cargarPdf(user) {
    if (!user.id) {
      user.id = new Date();
    }
    return dbapp.ref('DocPDF/' + user.id).set(user);
  }

  guardarSolicitudesPending(soli) {
    if (!soli.id) {
      soli.id = new Date();
    }
    return dbapp.ref('Solicitudes_Pendientes/' + soli.id).set(soli);
  }

  guardarSolicitudesPendingNormal(soli) {
    if (!soli.id) {
      soli.id = new Date();
    }
    return dbapp.ref('SolicitudesPendientesNormal/' + soli.id).set(soli);
  }

  guardarUsuarios(user) {
    if (!user.id) {
      user.id = new Date();
    }
    return dbapp.ref('usuarios/' + user.id).set(user);

  }

  guardarConductoresCoord(user) {
    if (!user.id) {
      user.id = new Date();
    }
    return dbapp.ref('UsuariosConductor/' + user.id).set(user);
  }

  guardarConductores(user) {
    if (!user.id) {
      user.id = new Date();
    }
    return dbapp.ref('Conductores/' + user.id).set(user);
  }

  removerUserFB(user) {
    return dbapp.ref('usuarios/' + user.id).remove();
  }

  removerUserFBS() {
    return dbapp.ref('usuarios/' + id).remove();
  }

  guardarIngresos(user) {
    if (!user.id) {
      user.id = new Date();
      user.fechaIngreso = user.id;
    }
    return dbapp.ref('IngresosAdmin/' + user.id).set(user);

  }

  guardarSolicitudesVerificadas(soli) {
    if (!soli.id) {
      soli.id = new Date();
    }
    return dbapp.ref('Solicitudes_Verificadas/' + soli.id).set(soli);
  }

  getSolicitudesVerificadas(soli) {
    return dbapp.ref("Solicitudes_Verificadas/" + soli.id);

  }

  getSolicitudesPending() {

  }

  removerSolicitudFB(soli) {
    return dbapp.ref('SolicitudesParaConductor/' + soli.id).remove();
  }
  removerSolicitudFBNormal(soli) {
    return dbapp.ref('SolicitudesConductorNormal/' + soli.id).remove();
  }

  cargarBoletasVerif(pago) {
    if (!pago.id) {
      pago.id = new Date();
    }
    return dbapp.ref('PagosVerificados/' + pago.id).set(pago);
  }

 
  registerUser(user, datosUser, vehiculo, rol) {
    
         // this.verificarEmail()
          this.RegistroUser(user, datosUser, vehiculo, rol);
        
  }

  guardarRegistros(){
   // this.verificarEmail()
    this.RegistroUser(res.user, datosUser, vehiculo, rol);
  }

  verificarEmail(){
    firebase.auth().currentUser.sendEmailVerification()
  .then(() => {
    // Email verification sent!
    // ...
  });
  }


  RegistroUser(user, datosUser, vehiculo, rol) {
    let users = {
      id: user.uid,
      displayName: datosUser.nombre,
      genero: datosUser.genero,
      email: user.email,
      code: Math.random().toString(36).substring(2, 8),
      photoURL: datosUser.fotoUser,
      emailVerified: user.emailVerified,
      phoneNumber: datosUser.celular,
      viajes_Realizados: 0,
      viajes_Activos: 0,
      status: true,
      bloqueado: false,
      ganancias: 0,
      gananciasRay: 0,
      viajes_Cancelados: 0,
      totalQviajes: 0,
      datosVehiculo: [
        {
          titulo: 'Marca',
          value: vehiculo.marcaVehi
        },
        {
          titulo: 'Color',
          value: vehiculo.colorVehi
        },
        {
          titulo: 'Placa',
          value: vehiculo.numPlaca
        },
        {
          titulo: 'Linea',
          value: vehiculo.linea
        },
        {
          titulo: 'Auto',
          value: 'vacio'
        }
      ],
      token: 'notoken',
      coordenadas: {
        lat: '0',
        lng: '0'
      },
      ranting: {
        viajes_realizados: 0,
        punteo: 5,
        punteoglobal: 0

      },
      rol: rol,
    }

    this.guardarConductores(users).then((data)=>{
      console.log("Datos enviados correctametne user ")
    }).catch((e)=>{
      console.log("Eeeroe de carga :", e)
    });
  }

}

export default new FirebaseService();


// WEBPACK FOOTER //
// ./src/services/firebaseservice.js